export const OPTIONS = {
    "saml": [
        { "type": "input", "label": "Reg. Id", "id": "registrationId", "disable": true, "hidden": true , "defaultValue":""},
        { "type": "input", "label": "Name", "id": "clientName","defaultValue":"" },
        { "type": "input", "label": "Local", "id": "local", "value": "true", "disable": true, "hidden": true,"defaultValue":"true" },
        { "type": "file", "label": "Upload Federation Xml", "id": "xmlPath", "formats": "xml","defaultValue":"" },
        { "type": "textarea_deprecated", "label": "(OR) Enter Federation Xml", "id": "xml", "hidden": true,"defaultValue":"" },
        { "type": "input", "label": "Extras", "id": "extras", "disable": true, "hidden": true ,"defaultValue":{}},
        { "type": "checkbox", "label": "Enable", "id": "enable","defaultValue":false }
    ]
}